export const TKeyAuth = {
  LOG_IN: "LOG_IN",
  SIGN_OUT: "SIGN_OUT",
  SIGN_UP: "SIGN_UP",
  SIGN_UP_EMAIL_SENT: "SIGN_UP_EMAIL_SENT",
  REMEMBER_ME: "REMEMBER_ME",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  RESET_MY_PASSWORD: "RESET_MY_PASSWORD",
  RESET_PASSWORD_EMAIL_SENT: "RESET_PASSWORD_EMAIL_SENT",
  DONT_HAVE_ACCOUNT: "DONT_HAVE_ACCOUNT",
  ALREADY_HAVE_ACCOUNT: "ALREADY_HAVE_ACCOUNT",
  CONTINUE_WITH_GOOGLE: "CONTINUE_WITH_GOOGLE",
  SIGN_UP_INVITE_REQUIRED: "SIGN_UP_INVITE_REQUIRED",
} as const;
